(function ($) {


const Init = (() => {

  // settings
  
  
  let website      = {},
      load         = {},
      resize       = {},
      scroll       = {},
      mod          = {},
      scrollOption = {},
      parallax     = {},
      drawer       = {},
      navi         = {},
      form         = {},
      formMethod   = {},
      timer        = {},
      wp           = {},
      iscroll      = {},
      loading      = {},
      totop        = {},
      scrollbar    = {},
      canvas       = {},
      tab          = {},
      favorite     = {},
      accordion    = {},
      page         = {},
      megamenu     = {};
  
  website = {
    page          : document.body.dataset.page,
    url           : document.URL,
    winWidth      : window.innerWidth,
    winHeight     : window.innerHeight,
    scrollY       : window.pageYOffset,
    breakpoint    : { xl:1600, pc: 1200, tb: 992, sp: 768, ss: 576 },
    ua            : navigator.userAgent.toLowerCase(),
    isDesktop     : true,
    isFirst       : true,
    animationFrame: null,
  
    headTag       : $('.l-header'),
  
    act           : 'is-act',
    actOpen       : 'is-open',
  
    targetAnime : 'js-anime',
    actAnime    : 'is-anime',
    shiftPoint  : 0,
    shiftPc     : 5,
    shiftSp     : 10,
  };
  website.shiftPoint = website.breakpoint.tb;
  
  load = {
    functions: [],
    length   : 0,
  };
  
  resize = {
    functions: [],
    length   : 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  scroll = {
    functions: [],
    length   : 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  page = {
    common: [],
    top   : [],
  };
  

  //modules
  // サニタイズ関数
  function sanitizing(str){
    var before = new Array('&','"',"'","<",">","\n","\t","\\n");
    var after = new Array('&amp;','&quot;','&rsquo;',"&lt;","&gt;","<br />"," ","<br />");
    for( var i=0; i < before.length; i++ )
      str = str.replace(new RegExp(before[i],'g'), after[i]);
    return str;
  };
  
  // LOAD
  const WinLoad = {
  
    init() {
      window.addEventListener('load', function(e) {
        WinLoad.update();
      });
  
      console.log('!-- load init --!');
    },
  
    add(func) {
      load.functions.push(func);
      load.length = load.functions.length;
    },
  
    remove(func) {
      load.functions.splice(func, 1);
      load.length = load.functions.length;
    },
  
    update() {
      for ( let i = 0; i < load.length; i++ ) {
        let func = load.functions[i];
        func();
      }
    },
  
  }
  
  // RESIZE
  const WinResize = {
  
    init() {
      window.addEventListener('resize', function(e) {
        if ( !resize.isRunning ) {
          resize.isRunning = true;
  
          resize.animationFrame = window.requestAnimationFrame( WinResize.update );
  
          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinResize.update();
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinResize.update();
          //   }, 1000/resize.fps);
          // }
        }
      });
  
      console.log('!-- resize init --!');
    },
  
    add(func) {
      resize.functions.push(func);
      resize.length = resize.functions.length;
    },
  
    remove(func) {
      resize.functions.splice(func, 1);
      resize.length = resize.functions.length;
    },
  
    update() {
      website.winWidth  = window.innerWidth;
      website.winHeight = window.innerHeight;
      website.ua        = navigator.userAgent.toLowerCase();
  
      for ( let i = 0; i < resize.length; i++ ) {
        let func = resize.functions[i];
        func();
      }
  
      resize.isRunning = false;
    },
  
  }
  
  // SCROLL
  const WinScroll = {
  
    init() {
      window.addEventListener('scroll', function(e) {
        if ( !scroll.isRunning ) {
          scroll.isRunning = true;
  
          scroll.animationFrame = window.requestAnimationFrame( WinScroll.update );
  
          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinScroll.update();
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinScroll.update();
          //   }, 1000/scroll.fps);
          // }
        }
      });
  
      console.log('!-- scroll init --!');
    },
  
    add(func) {
      scroll.functions.push(func);
      scroll.length = scroll.functions.length;
    },
  
    remove(func) {
      scroll.functions.splice(func, 1);
      scroll.length = scroll.functions.length;
    },
  
    update() {
      website.winHeight = window.innerHeight;
      website.scrollY = window.pageYOffset;
  
      for ( let i = 0; i < scroll.length; i++ ) {
        let func = scroll.functions[i];
        func();
      }
  
      scroll.isRunning = false;
    },
  
  }
  
  
  const Modules = {
  
    init() {
      mod = {
        targetSmooth    : 'js-scroll',
        targetTotop     : 'js-totop',
        smoothSpeed     : 600,
  
        targetModal     : 'js-modal',
        targetModalOpen : 'js-modalOpen',
        targetModalClose: 'js-modalClose',
  
        targetAlign     : 'js-align',
        targetAlignList : [],
        alignAddClass   : 'c-alignheight',
  
        targetOfi       : '.js-ofi .ofi',
  
        targetPagenavi  : 'js-pagenavi',
  
        targetDateField : 'js-datepicker',
  
        targetPullTrg   : 'js-pulldown',
        targetPullConts : 'js-pulldown_conts',
  
        confirmTrg      : 'js-confirmMsg',
  
        alertTrg        : 'js-alertMsg',
  
        removeTrg       : 'js-remove',
  
      };
  
      let alignList = document.querySelectorAll('.' + mod.targetAlign);
      mod.targetAlignList = Array.prototype.slice.call(alignList, 0);
  
      this.iosCheck();
      this.deviceCheck();
      this.smoothScroll();
      // this.tabBtn();
      // this.modalBtn();
      this.pulldown();
      this.confirmMessage();
      this.alertMessage();
  
      objectFitImages(mod.targetOfi);
      Stickyfill.add('.js-sticky');
    },
  
    iosCheck() {
      if ( website.ua.indexOf('ipad') > -1 || website.ua.indexOf('iphone') > -1 || (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document ) ) {
        $('body').addClass('ios');
      } else {
        $('body').removeClass('ios');
      }
    },
  
    deviceCheck() {
      if (
        website.ua.indexOf('iphone') > -1 ||
        website.ua.indexOf('ipod') > -1 ||
        website.ua.indexOf('android') > -1 && website.ua.indexOf('mobile') > -1
      ) {
        website.isDesktop = false;
        $('body').removeClass('pc tablet').addClass('sp');
      } else if (
        website.ua.indexOf('ipad') > -1 ||
        website.ua.indexOf('Android') > -1 ||
        (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document )
      ) {
        website.isDesktop = false;
        $('body').removeClass('pc sp').addClass('tablet');
      } else {
        website.isDesktop = true;
        $('body').removeClass('tablet sp').addClass('pc');
      }
    },
  
    smoothScroll() {
      $('.' + mod.targetSmooth + ':not([href=""])').on('click', function() {
        let href     = $(this).attr("href"),
            target   = $( (href == "#") ? 'html' : href ),
            position;
        if( website.headTag.css('position') == 'fixed' ){
          shift    = ( (href != "#") ) ? website.headTag.outerHeight() : 0
        }else{
          shift    = 50;
        }
        position = target.offset().top - shift;
        $('body,html').animate({scrollTop: position}, mod.smoothSpeed, 'swing');
        return false;
      });
    },
  
    // modalBtn() {
    //   $('.'+mod.targetModalOpen).on('click',function(){
    //     $('body').addClass('is-modalOpen');
    //     let target = $(this).attr('href');
    //     $(target).fadeIn();
    //     return false;
    //   });
    //   $('.'+mod.targetModalClose).on('click',function(){
    //     $('body').removeClass('is-modalOpen');
    //     $(this).closest('.'+mod.targetModal).fadeOut();
    //     return false;
    //   });
    // },
  
    alignHeight() {
      let alignHeight  = 0;
  
      mod.targetAlignList.forEach((target) => {
        target.style.minHeight = 'auto';
        target.classList.add(mod.alignAddClass);
        alignHeight = ( target.offsetHeight > alignHeight ) ? target.offsetHeight: alignHeight;
        target.classList.remove(mod.alignAddClass);
      });
      mod.targetAlignList.forEach((target) => {
        target.style.minHeight = alignHeight + 'px';
      });
    },
  
    pulldown (){
      if(website.winWidth >= website.shiftPoint){
        $('.'+ mod.targetPullTrg).hover(
          function(){
            $(this).addClass('is-act');
            $(this).children('.'+mod.targetPullConts).addClass('is-act').stop().slideDown();
          },
          function(){
            $(this).removeClass('is-act');
            $(this).children('.'+mod.targetPullConts).removeClass('is-act').stop().slideUp();
          }
        )
      } else{
        $('.'+mod.targetPullTrg).children('a').on('click',function(){
          $(this).parent('.'+mod.targetPullTrg).find('.'+mod.targetPullConts).toggleClass('is-act').stop().slideToggle();
          if(!$(this).parent('.'+mod.targetPullTrg).hasClass('is-act')){
            $(this).parent('.'+mod.targetPullTrg).toggleClass('is-act');
            return false;
          }else{
            $(this).parent('.'+mod.targetPullTrg).toggleClass('is-act');
          }
        });
      }
    },
  
    confirmMessage() {
      if( $('.' + mod.confirmTrg ).length ){
        $('.' + mod.confirmTrg ).on('click', function(){
          let message = $(this).attr('data-confirm-message'),
              redirect = $(this).attr('data-url');
          let result = window.confirm(message);
  
          console.log(result);
          if( result ){
            window.location.href = redirect;
          }
        });
      }
    },
  
    alertMessage() {
      if( $('.' + mod.alertTrg ).length ){
        $('.' + mod.alertTrg ).on('click', function(){
          let message = $(this).attr('data-alert-message');
          alert(message);
        });
      }
    },
    removeElement() {
      $('.'+mod.removeTrg).on('click',function(){
        let target = $(this).data('target');
        $(target).remove();
        return false;
      });
    },
  }
  
  const DrawerMenu = {
  
    init() {
      drawer = {
        panel     : 'js-so_panel',
        menu      : 'js-so_menu',
        duration  : 10,
        // openclass : 'slideout-open',
        toggleList: '#js-so_toggle',
        closeList : '#js-so_panel, #js-so_menu .js-scroll',
      };
  
      this.menu();
    },
  
    menu() {
      let slideoutInst = new Slideout({
        'panel': document.getElementById(drawer.panel),
        'menu': document.getElementById(drawer.menu),
        'duration': drawer.duration,
        // 'openclass': drawer.openclass,
      });
  
      let nodeList = document.querySelectorAll(drawer.toggleList);
      let node = Array.prototype.slice.call(nodeList,0);
      node.forEach(function(elem, index){
        elem.addEventListener('click', function() {
          slideoutInst.toggle();
        });
      });
  
      let nodeListClose = document.querySelectorAll(drawer.closeList);
      let nodeClose = Array.prototype.slice.call(nodeListClose,0);
      nodeClose.forEach(function(elem, index){
        elem.addEventListener('click', function() {
          slideoutInst.close();
        });
      });
    },
  
  }
  
    const Animation = {
  
      init() {
      },
  
      check() {
        $('.' + website.targetAnime + ':not(.' + website.actAnime + ')').each(function(){
          let self = $(this),
              targetPosition = self.offset().top,
              triggerPosition,
              shift;
  
          if( website.winWidth < website.shiftPoint ) {
            shift = website.winHeight / website.shiftSp;
          } else {
            shift = website.winHeight / website.shiftPc;
          }
          triggerPosition = targetPosition - website.winHeight + shift;
  
          if( website.scrollY > triggerPosition ){
            self.addClass(website.actAnime);
          }
        });
      },
  
    }
  
  const Slick = {
  
    init() {
      this.topKey();
    },
  
    topKey() {
      if($('.js-kv').length){
        let autospeed = 5000;
        $('.js-kv').slick({
          fade: true,
          autoplay: true,
          autoplaySpeed: autospeed,
          speed: 1000,
          cssEase: 'linear',
          arrows: false,
          dots: false,
          pauseOnFocus: false,
          pauseOnHover: false,
          responsive: [
            {
              // breakpoint: website.breakpoint.ss,
              // settings: {
              //   dots: false,
              // }
  
            },],
        });
      }
    },
  
  }
  
  const Megamenu = {
  
    init() {
      megamenu = {
        wrapElm     : '.js-megaWrap',
        trgElm      : '.js-megaTrg',
        contElm     : '.js-megaCont',
      }
      this.action();
    },
    action(){
      $(megamenu.wrapElm).hover(
        function(){
          $(this).children(megamenu.contElm).stop().slideDown();
        },
        function(){
          $(this).children(megamenu.contElm).stop().slideUp();
        }
      );
    },
  }
  
  const Totop ={
    init(){
      totop = {
        targetClass : '.js-totop',
        speed       : 600,
      }
      if($(totop.targetClass).length){
        this.check();
        this.action();
      }
    },
    check(){
      if( website.scrollY > 100 ){
        $( totop.targetClass ).addClass('is-act').fadeIn(400);
      }else{
        $( totop.targetClass ).removeClass('is-act').fadeOut(400);
      }
    },
    action(){
      $( totop.targetClass ).on('click',function(){
        $('body,html').animate({scrollTop: 0}, totop.speed, 'swing');
        return false;
      });
    }
  }
  
  const Timer = {
    init() {
      timer = {
        targetClass : '.js-timer',
      };
      this.check();
    },
    check() {
      if($(timer.targetClass).length){
        $(timer.targetClass).each(function(){
          let startTime   = new Date($(this).data('start')),
              endTime     = new Date($(this).data('end')),
              currentTime = new Date();
          if(!(startTime <= currentTime && currentTime <= endTime)){
            $(this).hide();
          }
        });
      }
    }
  }
  
  const Tab = {
  
    init() {
      tab = {
        wrapElm  : '.js-tabWrap',
        trgElm   : '.js-tabTrg',
        contElm  : '.js-tabCont',
        initFlag : false,
      }
  
      if($(tab.wrapElm).length && $(tab.trgElm).length && $(tab.contElm).length ){
        $(tab.wrapElm).each(function(){
          let wrap    = $(this),
              trigger = $(this).find(tab.trgElm),
              content = $(this).find(tab.contElm);
  
          if($(this).attr('data-tab-type') == 'pulldown'){
            Tab.pulldown_action( wrap, trigger, content );
          }else{
            Tab.default_action( wrap, trigger, content );
          }
        });
      }
    },
    default_action ( $wrap, $trigger, $content ){
      let tabTrg = $trigger.children('li').children('a');
      tabTrg.on('click',function(){
        let tabHref = $(this).attr('href'),
            tabObj = $(this).parent('li').siblings('li').children('a'),
            targetCont = $(this).closest(tab.wrapElm).find(tab.contElm),
            targetObj = targetCont.find(tabHref),
            contsObj = targetObj.siblings();
            tabObj.removeClass('is-act');
            $(this).addClass('is-act');
            contsObj.hide();
            targetObj.fadeIn();
            return false;
      });
      $(this).children('li').eq(0).children('a').click();
    },
    pulldown_action ( $wrap, $trigger, $content ){
      let target;
      if(tab.initFlag == false){
        target = $trigger.val();
        $content.children().hide();
        if(target !== ''){
          $content.find('#'+target).fadeIn().siblings().find('input[type="checkbox"]').prop('checked',false);
        }
        tab.initFlag  = true;
      }
      $trigger.change(function(){
        target = $(this).val();
        $content.children().hide().find('input[type="checkbox"]').prop('checked',false);
        if(target !== ''){
          $content.find('#'+target).fadeIn();
        }
      });
    }
  }
  
  const Accordion = {
  
    init() {
      accordion = {
        toggleElm : '.js-accordion',
        openElm   : '.js-accordionOpen',
        closeElm   : '.js-accordionClose',
      };
      this.toggle();
      this.open();
      this.close();
    },
  
    toggle() {
      if($(accordion.toggleElm).length){
        $(accordion.toggleElm).on('click', function(){
          let target = $(this).attr('data-accordion-content');
          if( target && $(target).length){
            if ( $(this).hasClass(website.act) ) {
              $(this).removeClass(website.act);
              $(target).stop().slideUp('fast');
              return false;
            } else {
              $(this).addClass(website.act);
              $(target).stop().slideDown();
              return false;
            }
          }else{
            if ( $(this).hasClass(website.act) ) {
              $(this).removeClass(website.act).next().stop().slideUp('fast');
            } else {
              $(this).addClass(website.act).next().stop().slideDown();
            }
          }
        });
      }
    },
    open() {
      if($(accordion.openElm).length){
        $(accordion.openElm).on('click', function(){
          let target = $(this).attr('data-accordion-content');
          if( target && $(target).length){
            if ( !$(this).hasClass(website.act) ) {
              $(this).addClass(website.act);
              $(target).stop().slideDown();
              $(this).hide();
              return false;
            }
          }else{
            if ( !$(this).hasClass(website.act) ) {
              $(this).addClass(website.act);
              $(this).addClass(website.act).next().stop().slideDown();
              $(this).hide();
            }
          }
        });
      }
    },
    close() {
      if($(accordion.closeElm).length){
        $(accordion.closeElm).on('click', function(){
          let target = $(this).attr('data-accordion-content');
          if( target && $(target).length){
            if ( $(this).hasClass(website.act) ) {
              $(this).removeClass(website.act);
              $(target).stop().slideUp('fast');
              $(this).hide();
              return false;
            }
          }else{
            if ( !$(this).hasClass(website.act) ) {
              $(this).removeClass(website.act).next().stop().slideUp('fast');
              $(this).hide();
            }
          }
        });
      }
    }
  
  }
  
  const Modal = {
  
    init() {
      modal = {
        openTrgElm    : '.js-modalOpen',
        closeTrgElm   : '.js-modalClose',
        slideElm      : '.js-modalSlide',
        targetElm     : '.js-modalCont',
        slideFlag     : false,
      };
      this.open();
      this.close();
    },
  
    open() {
      $(modal.openTrgElm).on('click',function(){
        let target = $(this).data('modal'),
            idx;
        $(modal.targetElm).show();
        $('html').addClass('is-modalOpen');
      });
    },
    close(){
      $(modal.closeTrgElm).on('click',function(){
        $(modal.targetElm).hide();
        $('html').removeClass('is-modalOpen');
      });
    },
  }
  
  const Wordpress = {
  
    init() {
      wp = {
        editorTarget: 'js-editor',
        tableClass  : 'c-tbl_responsive',
        tableInnerClass  : 'c-tbl_responsive__inner',
        iframeclass : 'c-iframe',
      }
  
      this.wpEditor();
    },
  
    wpEditor() {
      if ( $(wp.editorTarget).length ) {
        $( '.' + wp.editorTarget + ' table' ).each(function() {
          $(this).wrap('<div class="' + wp.tableClass + '"><div class="' + wp.tableInnerClass + '"></div></div>');
        });
        $( '.' + wp.editorTarget + ' iframe' ).each(function() {
          $(this).wrap('<div class="' + wp.iframeclass + '"></div>');
        });
      }
      // if ( $('.' + wp.editorTarget).length ) {
      //   $( '.' + wp.editorTarget + ' table' ).each(function() {
      //     $(this).wrap('<div class="' + wp.tableClass + '"></div>');
      //   });
      //   $( '.' + wp.editorTarget + ' iframe' ).each(function() {
      //     $(this).wrap('<div class="' + wp.iframeclass + '"></div>');
      //   });
      // }
    }
  
  }
  


  // OFF
  // ./inc/_loading.js
  // ./inc/_pagescroll.js
  // ./inc/_parallax.js
  // ./inc/_form.js
  // ./inc/_favorite.js


  // page
  const BasicPage = {
    init() {
      page.common = {
        menu: []
      };
      page.common.menu = {
        tabTrigger       : '.js-menuTabTrigger',
        tabContent       : '.js-menuTabContent',
        accordionTrigger : '.js-menuAccordion',
      }
      this.action();
    },
    action(){
      $(page.common.menu.tabTrigger).children('a').on('click',function(){
        let target = $(this).data('target');
        if( target !== undefined ){
          $(this).addClass('is-act').siblings().removeClass('is-act');
          $(page.common.menu.tabContent).children().hide();
          $(page.common.menu.tabContent).find(target).fadeIn();
          return false;
        }
      });
  
      $(page.common.menu.accordionTrigger).on('click',function(){
        $(this).toggleClass('is-act').next().slideToggle();
      });
    },
    update() {
    },
  }
  
  const TopPage = {
    init() {
      page.top = {
        kvSlide : '.js-homeKvSlide',
        featureSlide : [],
        newsTab : [],
      };
  
      page.top.featureSlide = {
        container : '.js-homeFeatureSlide',
        contoller : '.js-homeFeatureSlideController',
        arrows    : '.js-homeFeatureSlideArrows',
        dots      : '.js-homeFeatureSlideDots',
      };
  
      page.top.newsTab = {
        container : '.js-homeNewsTab',
        pulldown  : '.js-homeNewsTabSelect',
        trigger   : '.js-homeNewsTrigger',
        content   : '.js-homeNewsTabContent',
      };
  
      this.keySlide();
      this.newsTabAction();
      this.newsTabPulldown();
      this.newsTabInit();
      this.featureSlide();
      this.update();
    },
    keySlide() {
      let duration = $(page.top.kvSlide).data('duration'),
          delay    = $(page.top.kvSlide).data('delay');
      $(page.top.kvSlide).on('init',function(){
        $('.slick-current').addClass('is-anime');
      }).slick({
        fade: true,
        autoplay: true,
        autoplaySpeed: duration/2,
        speed: delay,
        slidesToShow : 1,
        slidesToScroll  : 1,
        arrows: false,
        dots: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive: [
          {
            // breakpoint: website.breakpoint.ss,
            // settings: {
            //   dots: false,
            // }
          },],
      }).on({
        beforeChange: function(event, slick, currentSlide, nextSlide){
          $(".slick-slide", this).eq(currentSlide).addClass('is-prev');
          $(".slick-slide", this).eq(nextSlide).addClass('is-anime');
        },
        afterChange: function() {
          $(".is-prev", this).removeClass("is-prev is-anime");
        }
      });
    },
    featureSlide(){
      if($(page.top.featureSlide.container).children().length >= 4){
        $(page.top.featureSlide.container).slick({
          fade: false,
          autoplay: false,
          autoplaySpeed: 5000,
          speed: 1000,
          cssEase: 'linear',
          slidesToShow : 4,
          slidesToScroll  : 1,
          infinite: false,
          arrows: true,
          dots: true,
          pauseOnFocus: false,
          pauseOnHover: false,
          appendArrows: $(page.top.featureSlide.arrows),
          nextArrow: '<button type="button" class="slideArrow -next"></button>',
          prevArrow: '<button type="button" class="slideArrow -prev"></button>',
          appendDots: $(page.top.featureSlide.dots),
          dotsClass: 'slideDots',
          responsive: [
            {
              breakpoint: website.breakpoint.pc,
              settings: {
                slidesToShow  : 3,
              }
            },
            {
              breakpoint: website.breakpoint.sp,
              settings: {
                slidesToShow  : 2,
              }
            },
            {
              breakpoint: website.breakpoint.ss,
              settings: {
                fade: true,
                slidesToShow  : 1,
              }
            },
          ],
        });
      }
    },
    newsTabInit(){
      $(page.top.newsTab.content).children().hide();
      $(page.top.newsTab.trigger).children().eq(0).children('a').click();
    },
    newsTabAction() {
      $(page.top.newsTab.trigger).find('a').on('click',function(){
        let target = $(this).attr('href');
        $(page.top.newsTab.pulldown).removeClass('is-act').text($(this).text());
        $(page.top.newsTab.content).children().hide();
        $(this).addClass('is-act').parents('li').siblings('li').children('a').removeClass('is-act');
        $(page.top.newsTab.content).find(target).fadeIn();
        if( website.winWidth <= website.breakpoint.sp ){
          $(page.top.newsTab.trigger).slideUp(400);
        }
        return false;
      });
    },
    newsTabPulldown(){
      $(page.top.newsTab.pulldown).on('click',function(){
        if( website.winWidth <= website.breakpoint.sp ){
          $(this).addClass('is-act').next(page.top.newsTab.trigger).slideToggle(400);
        }
      });
    },
    update() {
    },
  
  }
  



  const App = {

    init() {
      if ( website.page != 'wp-manual' && website.page != 'wp-manual-single' ) {
        this.set();
        // this.update();
      } else {
        // Modules.init();
        // Wordpress.init();
      }
    },

    set() {
      Modules.init();
      DrawerMenu.init();
      Wordpress.init();
      Accordion.init();
      Modal.init();
      Megamenu.init();
      Tab.init();
      BasicPage.init();
      // Animation.init();
      // PageScroll.init();
      // Parallax.init();


      if ( website.page == 'top' ) {
        TopPage.init();
      }

      WinLoad.add( Animation.check );
      // WinLoad.add( Modules.megaMenu );
      // WinLoad.add( Iscroll.check );

      WinResize.add( Modules.iosCheck );
      WinResize.add( Modules.deviceCheck );

      WinScroll.add( Animation.check );
      // WinScroll.add( Totop.check );
      // WinScroll.add( Iscroll.check );


      WinLoad.init();
      WinResize.init();
      WinScroll.init();

    },

    // update() {
    //   website.animationFrame = window.requestAnimationFrame( App.update );
    //   website.winWidth       = window.innerWidth;
    //   website.winHeight      = window.innerHeight;
    //   website.scrollY        = window.pageYOffset;

    //   if ( website.isDesktop ) {
    //     PageScroll.smooth();

    //     if ( website.page == 'top' ) {
    //       Parallax.moveImg();
    //     }
    //   }
    // },

  }


  App.init();

})();


})(jQuery);
